// Background experiment, dev/tunnel only: tap a dot, the page repaints.
const lab = document.querySelector("[data-bg-lab]")
const host = location.hostname
if (lab && (host === "localhost" || host === "127.0.0.1" || host.endsWith(".ngrok-free.app") || host.endsWith(".ngrok.app"))) {
  const options = [
    ["Paper (current)", "#FAFAF7"],
    ["Paper, a touch lighter", "#FBFBF9"],
  ]
  lab.hidden = false
  const saved = (() => { try { return localStorage.getItem("tz_bg_lab") } catch { return null } })()
  for (const [name, hex] of options) {
    const b = document.createElement("button")
    b.type = "button"
    b.title = `${name} ${hex}`
    b.style.cssText = `width:26px;height:26px;border-radius:999px;background:${hex};border:1px solid var(--color-line);cursor:pointer`
    b.addEventListener("click", () => {
      document.documentElement.style.setProperty("--color-paper", hex)
      ;[...lab.children].forEach((c) => (c.style.outline = ""))
      b.style.outline = "2px solid var(--color-periwinkle)"
      try { localStorage.setItem("tz_bg_lab", hex) } catch {}
    })
    lab.appendChild(b)
    if ((saved && saved === hex) || (!saved && hex === "#FAFAF7")) b.style.outline = "2px solid var(--color-periwinkle)"
  }
  if (saved) document.documentElement.style.setProperty("--color-paper", saved)
}
